import CircularProgress from '@material-ui/core/CircularProgress';
import React from 'react';
import { connect } from 'react-redux';
import { Services } from '@configuratorware/configurator-frontendgui/App/ServiceLocator';
import { getShareUrl } from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Selectors';
import CustomSaveConfiguration from './CustomSaveConfiguration';

const mapStateToProps = ({ ui, configurator }) => ({
  Component: CustomSaveConfiguration,
  ProgressComponent: CircularProgress,
  show: !!ui.visibilityMap.saveConfiguration,
  workInProgress: !!ui.backgroundWorkMap.saveConfiguration,
  errorMessage: ui.error && ui.error.message,
  code: configurator.configuration.code || '',
  savedconfiguration: configurator.configuration,
  loadLoginInfoInProgress: !!ui.backgroundWorkMap.loadLoginInfo,
  shareUrl: getShareUrl(configurator),
});

const mapDispatchToProps = () => ({
  onClose: () => Services.ui.hide('saveConfiguration'),
  onOkClick: () => Services.ui.hide('saveConfiguration'),
});

const ComponentContainer = ({ Component, ...props }) => Component && <Component {...props} />;

export default connect(mapStateToProps, mapDispatchToProps)(ComponentContainer);
